import { getToken } from '../auth/tokenStore';
import { apiBaseUrl } from '../index';

// Define the onboarding update request interface
export interface OnboardingUpdateRequest {
  sector?: string;
  role?: string;
  attemptedTest?: boolean;
  finishedTest?: boolean;
  progress: number;
}

// Update onboarding progress
export const updateOnboarding = async (data: OnboardingUpdateRequest): Promise<void> => {
  const accessToken: string = await getToken();
  const response = await fetch(`${apiBaseUrl}/users/me/onboarding`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`
    },
    body: JSON.stringify(data)
  });

  if (!response.ok) {
    throw new Error(`${await response.text()}`);
  }
};
